import * as THREE from "three";

extendMeshBasicMaterialWithEmissiveIntensity();

const materialList = [];

export const materials = {
    list: materialList,
    setMaterial: setMaterial,
    updatableMaterials: [],
    getMaterial: getMaterial,
};

function getMaterial(name) {
    return materialList.find((mat) => mat.name === name);
}

function setMaterial(object) {
    let existingMaterial;
    if (materialList.length > 0) {
        existingMaterial = materialList.find((mat) => mat.name === object.material.name);
    }

    if (existingMaterial) {
        object.material = existingMaterial.isUnique ? existingMaterial.clone() : existingMaterial;
        return;
    }

    if (object.material.type === "MeshBasicMaterial") {
    }
	if(object.material.map)  object.material.map.anisotropy = 16; 
	if(object.material.roughnessMap) object.material.roughnessMap.anisotropy = 16; 
	if(object.material.aoMap) object.material.aoMap.anisotropy = 16; 
	if(object.material.alphaMap) object.material.alphaMap.anisotropy = 16; 
	if(object.material.normalMap) {
        object.material.normalMap.anisotropy = 16;
    } 
	
	materialList.push(object.material);

    if (object.material.name === "glass") {
        const envMapPosition = new THREE.Vector3(0, 1.88, 3.65);
        const envMapSize = new THREE.Vector3(20, 7, 24); 
        object.material.onBeforeCompile = shader => useBoxProjectedEnvMap(shader, envMapPosition, envMapSize);
    }
    if (object.material.name === "bathhouse_glass") {
        const envMapPosition = new THREE.Vector3(21, 1.74, -4.17);
        const envMapSize = new THREE.Vector3(8, 8, 8); 
        object.material.onBeforeCompile = shader => useBoxProjectedEnvMap(shader, envMapPosition, envMapSize);
    }
    if (object.material.name === "jeep_glass" || 
        object.material.name === "jeep_body" || 
        object.material.name === "jeep_dark_glass" ||
        object.material.name === "jeep_black_glossy" ||
        object.material.name === "jeep_red_glossy" ||
        object.material.name === "jeep_chrome") 
    {
        const envMapPosition = new THREE.Vector3(-6.5, 0, 10.8);
        const envMapSize = new THREE.Vector3(5, 5, 5); 
        object.material.onBeforeCompile = shader => useBoxProjectedEnvMap(shader, envMapPosition, envMapSize);
    }
    
}

function extendMeshBasicMaterialWithEmissiveIntensity() {
    Object.defineProperty(THREE.MeshBasicMaterial.prototype, "emissiveIntensity", {
        get: function () {
            return this._emissiveIntensity !== undefined ? this._emissiveIntensity : 1.0;
        },
        set: function (value) {
            this._emissiveIntensity = value;
            if (this.userData && this.userData.shader) {
                this.userData.shader.uniforms.emissiveIntensity.value = value;
            }
        },
    });

    THREE.MeshBasicMaterial.prototype.onBeforeCompile = function (shader) {
        shader.uniforms.emissiveIntensity = { value: this.emissiveIntensity };
        shader.fragmentShader = "uniform float emissiveIntensity;\n" + shader.fragmentShader;
        shader.fragmentShader = shader.fragmentShader.replace(
            "vec4 diffuseColor = vec4( diffuse, opacity );",
            "vec4 diffuseColor = vec4( diffuse * emissiveIntensity, opacity );",
        );
        this.userData.shader = shader;
    };
}


export function useBoxProjectedEnvMap(shader, envMapPosition, envMapSize) {
    const worldposReplace = /* glsl */`
    #if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )
        vec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );
        #ifdef BOX_PROJECTED_ENV_MAP
            vWorldPosition = worldPosition.xyz;
        #endif
    #endif
    `;

    const boxProjectDefinitions = /*glsl */`
    #ifdef BOX_PROJECTED_ENV_MAP
        uniform vec3 envMapSize;
        uniform vec3 envMapPosition;
        varying vec3 vWorldPosition;
        
        vec3 parallaxCorrectNormal( vec3 v, vec3 cubeSize, vec3 cubePos ) {
            vec3 nDir = normalize( v );
            vec3 rbmax = ( .5 * cubeSize + cubePos - vWorldPosition ) / nDir;
            vec3 rbmin = ( -.5 * cubeSize + cubePos - vWorldPosition ) / nDir;
            vec3 rbminmax;
            rbminmax.x = ( nDir.x > 0. ) ? rbmax.x : rbmin.x;
            rbminmax.y = ( nDir.y > 0. ) ? rbmax.y : rbmin.y;
            rbminmax.z = ( nDir.z > 0. ) ? rbmax.z : rbmin.z;
            float correction = min( min( rbminmax.x, rbminmax.y ), rbminmax.z );
            vec3 boxIntersection = vWorldPosition + nDir * correction;
            
            return boxIntersection - cubePos;
        }
    #endif
    `;

    // will be inserted after "vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );"
    const getIBLIrradiance_patch = /* glsl */`
    #ifdef BOX_PROJECTED_ENV_MAP
        worldNormal = parallaxCorrectNormal( worldNormal, envMapSize, envMapPosition );
    #endif
    `;

    // will be inserted after "reflectVec = inverseTransformDirection( reflectVec, viewMatrix );"
    const getIBLRadiance_patch = /* glsl */`
    #ifdef BOX_PROJECTED_ENV_MAP
        reflectVec = parallaxCorrectNormal( reflectVec, envMapSize, envMapPosition );
    #endif
    `;

    // defines
    shader.defines.BOX_PROJECTED_ENV_MAP = true;

    // uniforms
    shader.uniforms.envMapPosition = {
        value: envMapPosition
    };

    shader.uniforms.envMapSize = {
        value: envMapSize
    };

    // vertex shader
    shader.vertexShader = "varying vec3 vWorldPosition;\n" + shader.vertexShader
        .replace(
            "#include <worldpos_vertex>",
            worldposReplace
        );

    // fragment shader
    shader.fragmentShader = boxProjectDefinitions + "\n" + shader.fragmentShader
        .replace(
            "#include <envmap_physical_pars_fragment>",
            THREE.ShaderChunk.envmap_physical_pars_fragment
        )
        .replace(
            "vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );",
            `
            vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
            ${getIBLIrradiance_patch}
            `
        )
        .replace(
            "reflectVec = inverseTransformDirection( reflectVec, viewMatrix );",
            `
            reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
            ${getIBLRadiance_patch}
            `
        );
}